const initialState = {
    data: null
}

export default (state = initialState, action) => {
    switch(action.type){
        case 'GET_STRIPE_CONF_OK':
            return {
                data : {...action.data}
            }
        case 'CHANGE_STRIPE_CONF_OK':
            return {
                data: {...action.data}
            }
        default : 
            return {
                ...state
            }
    }
}